import { MenuService } from './../../services/menu.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-test-prep',
  templateUrl: './test-prep.component.html',
  styleUrls: ['./test-prep.component.scss']
})
export class TestPrepComponent implements OnInit {
  testPrepJson = { url: '' };
  currentPageId;

  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _menuService: MenuService
  ) { }

  ngOnInit() {
    this.getTestPrepJsonData();
    this.extendSession();
  }

  extendSession() {
    this._commonRequestResponseService.postWithHeader('shared/session/extend', {})
    .subscribe(
      (res: any) => {
        // ???
      },
      (error) => {
        // ???
      });
  }

  getTestPrepJsonData() {
    const inputJson = {};

    this._commonRequestResponseService.postWithHeader('shared/testprep', inputJson)
      .subscribe(
        (testPrepJson: any) => {
          this.getPageData();
          this.testPrepJson['url'] = testPrepJson['url'];
          window.open(testPrepJson['url']);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching test prep data');
        });
  }

  getPageData() {
    this.currentPageId = this._menuService.getCurrentPageId();
  }
}
